/* eslint-disable */
window.addEventListener('load', () => {
  patternBlock.init();
});

const patternBlock = {
  init: function () {
    const sections = document.querySelectorAll('[data-pattern-block-js]');

    if (!sections.length) return;

    sections.forEach((section) => {
      this.addColsToRows(section);
      this.initAnimation(section);

      window.addEventListener('resize', () => {
        this.removeColsFromRows(section);
        this.addColsToRows(section);
        this.initAnimation(section);
      });
    })

  },

  addColsToRows: function (section) {
    const parentEl = section.querySelector('[data-parent-js]');
    const rows = section.querySelectorAll('[data-row-js]');

    rows.forEach((row) => {
      this.insertCols(row, parentEl);
    })
  },

  removeColsFromRows: function (section) {
    const rows = section.querySelectorAll('[data-row-js]');

    rows.forEach((row) => {
      row.innerHTML = '';
    })
  },

  initAnimation: function (section) {
    const allSVGs = section.querySelectorAll('[data-row-js] svg');
    let currentIndex = -1;
    let resizeChecker = false;

    const itemAnimation = () => {
      if (resizeChecker) return;

      const activeSvg = section.querySelector('[data-row-js] svg.active');
      if (activeSvg) {
        activeSvg.classList.remove('active');
      }

      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * allSVGs.length);
      } while (newIndex === currentIndex);

      currentIndex = newIndex;
      allSVGs[currentIndex].classList.add('active');
    };

    const handleResize = () => {
      resizeChecker = true;
    };

    setTimeout(itemAnimation, 1);
    setInterval(itemAnimation, 5000);

    window.addEventListener('resize', handleResize);
  },

  getColsCount: function (windowWidth) {
    let colStartWidth = 100;
    return windowWidth / colStartWidth;
  },

  getColsWidth: function (windowWidth, colsCount) {
    return windowWidth / colsCount;
  },

  insertCols: function (row, parentEl) {
    let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const colsCount = this.getColsCount(windowWidth);
    const colsWidth = this.getColsWidth(windowWidth, colsCount);
    for (let i = 0; i < colsCount; i++) {
      let cloneEl = parentEl.cloneNode(true);
      cloneEl.removeAttribute('data-parent-js');
      cloneEl.style.width = `${colsWidth}px`;
      row.appendChild(cloneEl);
    }
  },

}

export default patternBlock;
